import { useEffect, useState } from 'react';
import Careerbg from '../../Assets/Home/CareerBg.png';
import searchicon from '../../Assets/Home/searchicon.svg';
import categoryicon from '../../Assets/Home/Categoryicon.svg';
import arrowblog from "../../Assets/Home/arrowblog.svg";
import subscribeicon from "../../Assets/Home/subscribe.svg";
import CareerFooter from "../../Assets/Home/CareerFooter.png";
import { API, MEDIA_URL2 } from '../../axios';
import PositionSkeleton from './PositionSkeleton';
import PositionCards from './PositionCards';
import MobCareerFooter from "../../Assets/Home/MobCareerFooter.png";
import emailicon from "../../Assets/Home/email.svg";

const Hero = () => {
  const locationicon = MEDIA_URL2 + 'Career/location.svg';
  const experienceicon = MEDIA_URL2 + 'Career/experience.svg';
  const keywordsicon = MEDIA_URL2 + 'Career/keywords.svg';
  const dividericon = MEDIA_URL2 + 'Career/divider.svg';

  const [allVacancy, setAllVacancy] = useState([]);
  const [filteredVacancy, setFilteredVacancy] = useState([]);
  const [industry, setIndustry] = useState('');
  const [location, setLocation] = useState('');
  const [keyword, setKeyword] = useState('');
  const [isloading, setisloading] = useState(true);
  const [visibleJobs, setVisibleJobs] = useState(6);
  const [selectedCategory, setSelectedCategory] = useState('');

  const handleLoadMore = () => {
    setVisibleJobs((prevVisiblePosts) => prevVisiblePosts + 3);
  };

  useEffect(() => {
    const getVacancy = async () => {
      try {
        const res = await API.get(`/jd/jobpostfilter/active/beb197dd-9ad1-4136-a1ad-bb469e7127a2/`);
        console.log(res.data, "API Response"); // Add this log
        const activeVacancy = res.data.filter(job => job.status === 'active');
        console.log(activeVacancy, "Active Vacancies"); // Add this log
        setAllVacancy(activeVacancy);
        setFilteredVacancy(activeVacancy);
      } catch (err) {
        console.log('Error Occurred! Please try again after a while.', err);
      }
      setisloading(false);
    };
    getVacancy();
  }, []);

  const filterVacancies = () => {
    const filtered = allVacancy.filter(job => {
      return (
        (industry === '' || job.department_name.toLowerCase().includes(industry.toLowerCase())) &&
        (location === '' || job.location.toLowerCase().includes(location.toLowerCase())) &&
        (keyword === '' || job.position_name.toLowerCase().includes(keyword.toLowerCase())) &&
        (selectedCategory === '' || job.department_name.toLowerCase().includes(selectedCategory.toLowerCase()))
      );
    });
    setFilteredVacancy(filtered);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      filterVacancies();
    }
  };

  // const handleCategoryClick = (item) => {
  //   if (selectedCategory === item) {
  //     setSelectedCategory('');
  //     setFilteredVacancy(allVacancy);
  //   } else {
  //     setSelectedCategory(item);
  //     const filteredJobs = allVacancy.filter(job => job.department_name.toLowerCase() === item.toLowerCase());
  //     setFilteredVacancy(filteredJobs);
  //   }
  //   filterVacancies();
  // };

  return (
    <div className="w-full flex flex-col items-center">
      {/* Hero Section */}
      <div
        className="relative w-full flex items-center justify-center bg-cover bg-no-repeat bg-center"
        style={{
          margin: "95px 0 0",
          height: "70vh",
          backgroundImage: `url(${Careerbg})`
        }}

      >
        <style>
          {`
      @media (max-width: 1024px) {
        div[style] {
          height: 60vh !important;
        }
      }
    `}
        </style>

        <div className="relative flex flex-col items-center gap-8 md:gap-14 text-center text-white px-4 py-10">
          <h1 className="text-2xl md:text-5xl font-medium">Find Jobs, Hire Creatives</h1>
          <div className="relative flex flex-col md:flex-row items-center gap-4 md:gap-6 bg-white text-gray-700 p-4 md:p-6 shadow-lg rounded-xl w-[90vw] md:w-[80%]">
            {/* <div className="flex items-center gap-2 w-full md:w-1/3">
              <img src={experienceicon} alt="Industry" className="w-6" />
              <input
                type="text"
                placeholder="Industry"
                value={industry}
                onChange={(e) => setIndustry(e.target.value)}
                onKeyDown={handleKeyPress}
                className="w-full p-2 border-none focus:outline-none"
              />
            </div> */}
            <div className=" md:block w-px bg-gray-300"></div>
            {/* <div className="flex items-center gap-2 w-full md:w-1/3">
              <img src={locationicon} alt="Location" className="w-6" />
              <input
                type="text"
                placeholder="Location"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                onKeyDown={handleKeyPress}
                className="w-full p-2 border-none focus:outline-none"
              />
            </div> */}
            <div className="hidden md:block w-px bg-gray-300"></div>
            <div className="flex items-center gap-2 w-full md:w-1/3">
              <img src={keywordsicon} alt="Keywords" className="w-6" />
              <input
                type="text"
                placeholder="Keyword"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                onKeyDown={handleKeyPress}
                className="w-full p-2 border-none focus:outline-none"
              />
            </div>
            <button
              onClick={filterVacancies}
              className="flex items-center gap-2 bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition"
            >
              <img src={searchicon} alt="Search" className="w-5" />
              Search
            </button>
          </div>
        </div>
      </div>

      {/* Job Listings */}
      <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-6 px-4 md:px-10 my-8">

        {isloading && <PositionSkeleton cards={6} />}
        {
          console.log(filteredVacancy, "Filtered Vacancies")
        }
        {filteredVacancy.slice(0, visibleJobs).map((item, i) => (
          <PositionCards key={i} data={item} />
        ))}
      </div>

      {/* Load More */}
      {visibleJobs < filteredVacancy.length && (
        <div className="flex justify-center">
          <button
            onClick={handleLoadMore}
            className="flex items-center gap-2 px-6 py-2 border border-gray-800 text-gray-800 hover:border-purple-600 hover:text-purple-600 transition rounded-md"
          >
            Load More
            <img src={arrowblog} alt="Arrow" className="w-4" />
          </button>
        </div>
      )}

      {/* Footer */}
      <div
        className="w-full bg-cover bg-center flex flex-col items-center py-10 md:py-32 mb-10"
        style={{ backgroundImage: `url(${CareerFooter})` }}
      >
        <div className="text-center text-white px-4 md:px-20 max-w-[600px]">
          <h2 className="text-xl md:text-3xl font-semibold">
            New Things Will Always Update Regularly
          </h2>
        </div>
        <div className="w-[90%] md:w-[50%] mt-6 bg-white p-4 rounded-lg flex items-center gap-4 shadow-lg">
          <img src={emailicon} alt="Email" className="w-6" />
          <input
            type="email"
            placeholder="Enter your email"
            className="w-full focus:outline-none"
          />
          <button className="bg-purple-600 flex items-center gap-x-2 text-white pl-4 pr-10 py-2 rounded-lg hover:bg-purple-700 transition"><img src={subscribeicon} />
            Subscribe
          </button>
        </div>
      </div>
    </div>
  );
};




export default Hero;
